import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { MonthlyAnsweredTrendItem } from '../../models/insights-dashboard.model';

const ARABIC_MONTHS = [
  'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
  'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر',
];

@Component({
    selector: 'app-ask-ayen-questions-chart',
    templateUrl: './questions-chart.component.html',
    styleUrl: './questions-chart.component.scss',
    standalone: false
})
export class QuestionsChartComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() trend: MonthlyAnsweredTrendItem[] = [];

  chartId = 'ask-ayen-questions-chart';

  private viewInitialized = false;
  private chart?: Highcharts.Chart;
  private resizeObserver?: ResizeObserver;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    this.renderChart();

    // Highcharts doesn't reflow itself when its container resizes (sidebar toggle,
    // flex layout changes, window resize) — without this the chart keeps the pixel
    // size it had at first render.
    this.resizeObserver = new ResizeObserver(() => this.chart?.reflow());
    this.resizeObserver.observe(this.elementRef.nativeElement);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['trend'] && this.viewInitialized) {
      this.renderChart();
    }
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.chart?.destroy();
  }

  private formatMonth(month: string): string {
    const [year, monthNumber] = month.split('-');
    const monthName = ARABIC_MONTHS[Number(monthNumber) - 1] ?? month;
    return `${monthName} ${year}`;
  }

  private renderChart(): void {
    const categories = this.trend.map((item) => this.formatMonth(item.month));

    this.chart = Highcharts.chart(this.chartId, {
      chart: {
        type: 'column',
        height: 400,
        spacing: [30, 0, 0, 0],
        style: { fontFamily: 'cairo-semibold' },
      },
      title: { text: undefined },
      credits: { enabled: false },
      legend: { enabled: false },
      xAxis: {
        reversed: true,
        categories,
        labels: { style: { color: '#707585' } },
        lineColor: '#E7E8EB',
      },
      yAxis: {
        min: 0,
        opposite: true,
        title: { text: undefined },
        gridLineColor: '#F3F3F5',
      },
      tooltip: { shared: true },
      plotOptions: {
        column: {
          // Fixed px width (from Figma spec) instead of a fraction of the category slot —
          // otherwise bars stretch to fill the axis when there are only 1-2 months of data.
          // Note: pointPadding has no effect once pointWidth is fixed — the gap between the
          // two bars in a group is controlled entirely by groupPadding instead.
          pointWidth: 14,
          pointPadding: 0,
          groupPadding: 0.28,
          borderWidth: 0,
          borderRadius: 3,
        },
      },
      series: [
        {
          type: 'column',
          name: 'مجاب علية',
          color: '#40B58D',
          data: this.trend.map((item) => item.answered_count),
        },
        {
          type: 'column',
          name: 'غير مجاب',
          color: '#CED1D6',
          data: this.trend.map((item) => item.not_answered_count),
        },
      ],
    });
  }
}
